export default __webpack_public_path__ + "static/media/config-16px.52280a39.svg";